import React from 'react'

function Null() {
    return (
        <span className='cs-data-null'>Null</span>
    )
}

export { Null }